import * as amplitude from '@amplitude/analytics-browser';
import { initialize } from '@ashn/component-library-react/Amplitude';

let hasInitializedAnalytics = false;

function getAnalyticsOptions() {
	if (
		typeof window !== 'undefined' &&
		window.location.hostname === 'localhost'
	) {
		return {
			serverUrl: '/clinical/amplitude-proxy/amplitude',
			fetchRemoteConfig: false,
		};
	}

	return undefined;
}

export function initializeAnalytics() {
	if (hasInitializedAnalytics) {
		return;
	}

	try {
		const options = getAnalyticsOptions();

		if (options) {
			initialize({ amplitude, options });
		} else {
			initialize({ amplitude });
		}

		hasInitializedAnalytics = true;
	} catch (error) {
		console.debug(
			'Amplitude is not setup or not available right now.',
			error
		);
	}
}
